import util from "utils/utils"

import BaseChip, { type ChipConfiguration } from "./BaseChip"

const ProfileChip = ({
  profile,
  forType = "profile",
  ...props
}: ChipConfiguration & {
  forType?: "profile" | "organisation"
  profile: {
    _id: string
    name: string
    overview?: string
  }
}) => {
  return (
    <BaseChip
      {...props}
      style={{ maxWidth: 200 }}
      linkTo={forType === "profile" ? `/profiles/${profile?._id}` : null}
      title={profile?.name}
      subtitle={profile?.overview}
      imageUrl={util.profileLogo(profile)}
      avatarBackgroundSize={forType === "organisation" ? "contain" : "cover"}
    />
  )
}

export default ProfileChip
